// arrayToContinuousNormalized.jsx
import * as d3 from 'd3';

const colorSchemes = {
    'shannon_index_e': d3.interpolateViridis,
    'simpson_index': d3.interpolateInferno,
    'richnes': (t) => {
        const powerScale = d3.scalePow()
            .exponent(0.3)
            .domain([0, 1])
            .range([0, 1]);
        return d3.interpolateYlGnBu(powerScale(t));
    },
    'chao1': (t) => {
        const powerScale = d3.scalePow()
            .exponent(0.3)
            .domain([0, 1])
            .range([0, 1]);
        return d3.interpolateYlOrRd(powerScale(t));
    }
};


export default function arrayToContinuousNormalized(colorsData, scatterColorCategory, userValues = [], userColorMode = null) {
    if (!colorsData || colorsData.length === 0) {
        return [[], {}, []];
    }

    const minVal = d3.min(colorsData);
    const maxVal = d3.max(colorsData);

    const normalize = d3.scaleLinear()
        .domain([minVal, maxVal])
        .range([0, 1]);

    const normalizedValues = colorsData.map(value => normalize(value));

    const colorScale = d3.scaleSequential()
        .domain([0, 1])
        .interpolator(colorSchemes[scatterColorCategory] || d3.interpolateViridis);

    const ColorDict = {};
    const steps = 100;
    for (let i = 0; i <= steps; i++) {
        const val = i / steps;
        const color = d3.color(colorScale(val));
        ColorDict[val] = [color.r, color.g, color.b];
    }

    // Add a custom color for user points if needed
    let userColorIndex = null;
    if (userValues && userValues.length > 0) {
        // Choose a custom color for user points (purple)
        const userColor = [128, 0, 128];
        userColorIndex = Object.keys(ColorDict).length;
        ColorDict['__user__'] = userColor;
    }

    // Build color index list: base points + user points
    let colorIndexList = normalizedValues.map(val => {
        // Find the closest color step
        const step = Math.round(val * steps) / steps;
        return Object.keys(ColorDict).indexOf(step.toString());
    });

    if (userValues && userValues.length > 0) {
        // For user points, assign the custom color index
        for (let i = 0; i < userValues.length; i++) {
            colorIndexList.push(userColorIndex);
        }
    }

    return [[], ColorDict, colorIndexList];
}